import { builder } from '@comall-backend-builder/core';
import { config } from './index';

builder.registerConfig(config);
